module.exports = __webpack_public_path__ + "media/members/display_name_format-ff9e3e5d.png";